// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Kauppasi puhelimella',
    desktop: 'Kauppasi tietokoneella',
  },
  loading: 'Ladataan kuvakaappausta',
  failed: 'Kuvakaappauksen lataaminen epäonnistui.',
};
